import {Box} from '../Box';
import {Matm} from '../../../classes/Matm';

declare const THREE: any;

export class StairsUVGenerator {

  private readonly vAxis = new THREE.Vector3(0, 0, 1);
  private readonly uAxis = new THREE.Vector3(1, 0, 0);
  private readonly uvRange = {min: 0, max: 1};

  private static split(array: number[], by: number): number[][] {
    const result = [];
    let items = [];
    for (let i = 0; i <= array.length; i++) {
      if (i % by === 0 && i !== 0) {
        result.push(items);
        items = [];
      }
      items.push(array[i]);
    }
    return result;
  }

  private static findAverageY(vert: number[][]): number {
    const result = {min: Number.MAX_VALUE, max: 0};
    for (const v of vert) {
      result.min = Math.min(result.min, v[1]);
      result.max = Math.max(result.max, v[1]);
    }
    return result.max - result.min;
  }

  private static verticesAboveLimit(vert: number[][], limit: number): number[][] {
    const result = [];
    for (const v of vert) {
      if (v[1] > limit) {
        result.push(v);
      }
    }
    return result;
  }

  generate(box: Box, stepMesh): Float32Array {

    const {length, height, min} = box;
    const vertex = new THREE.Vector3();
    min.setY(0);

    const parent = stepMesh.parent;
    const geometry = stepMesh.geometry;
    const vertices = StairsUVGenerator.split(geometry.attributes.position.array, 3);
    const yLimit = StairsUVGenerator.findAverageY(vertices);
    const vtxs = StairsUVGenerator.verticesAboveLimit(vertices, yLimit);
    const uvs = [];
    vtxs.forEach(vtx => {
      vertex.set(vtx[0], 0, vtx[2]);
      parent.localToWorld(vertex);
      const vertexToOrigin = vertex.sub(min);
      const v = vertexToOrigin.clone().projectOnVector(this.vAxis).length();
      const u = vertexToOrigin.clone().projectOnVector(this.uAxis).length();
      const mappedV = Matm.mapRange({min: 0, max: height, value: v}, this.uvRange);
      const mappedU = Matm.mapRange({min: 0, max: length, value: u}, this.uvRange);
      uvs.push(mappedU, mappedV);
    });

    return Float32Array.from(uvs);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/lightMap/uvGenerator/StairsUVGenerator.ts